/**
 * Convert a display name into a URL-safe slug candidate. Mirrors the API-side
 * `OrbitalX.Business.Helpers.SlugHelper.Slugify` so the dashboard preview
 * matches what the server will accept.
 *
 * - Lowercases
 * - Strips accents (NFD + drop combining marks)
 * - Replaces any non-alphanumeric run with a single hyphen
 * - Trims leading/trailing hyphens
 * - Returns an empty string when nothing remains
 */
export function slugify(input) {
    if (!input)
        return '';
    const normalized = input.normalize('NFD').replace(/\p{M}/gu, '');
    const collapsed = normalized
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    return collapsed;
}
/**
 * Returns true when the string matches the canonical slug format the API
 * enforces: lowercase alphanumeric segments joined by single hyphens, 3-50 chars.
 */
export function isValidSlugFormat(slug) {
    if (!slug)
        return false;
    if (slug.length < 3 || slug.length > 50)
        return false;
    return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug);
}
